import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface InfoCardProps {
  heading?: string | number;
  subheading?: string;
  sx?: object;
}

const InfoCard: React.FC<InfoCardProps> = ({ heading, subheading, sx }) => (
  <Box
    sx={(theme) => ({
      backgroundColor: theme.palette.surface?.secondary,
      maxWidth: { md: 260 },
      width: '100%',
      height: { xs: 70, md: 104 },
      borderRadius: 2,
      boxShadow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      px: 2,
      py: 1,
      ...sx,
    })}
  >
    <Typography
      variant="h1"
      sx={{
        color: (theme) => theme.palette.brand.accent,
        fontSize: { xs: 18, md: 18, lg: 36 },
        fontWeight: 700,
        textAlign: 'left',
        lineHeight: 1.1,
        mb: 0.5,
      }}
    >
      {heading}
    </Typography>
    <Typography
      variant="subtitle1"
      sx={{
                color: (theme) => theme.palette.brand.accent,
        fontSize: { xs: 12, md: 16 },
        fontWeight: 400,
        textAlign: 'left',
        lineHeight: 1.1

      }}
    >
      {subheading}
    </Typography>
  </Box>
);

export default InfoCard;